// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface CreateDocumentDTO
 */
export interface CreateDocumentDTO {
    /**
     * 
     * @type {any}
     * @memberof CreateDocumentDTO
     */
    file: any;
    /**
     * 
     * @type {string}
     * @memberof CreateDocumentDTO
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDocumentDTO
     */
    type: CreateDocumentDTOTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum CreateDocumentDTOTypeEnum {
    SIGNEDTENANCYAGREEMENT = 'SIGNED_TENANCY_AGREEMENT',
    INVENTORYCHECKIN = 'INVENTORY_CHECK_IN',
    INVENTORYCHECKOUT = 'INVENTORY_CHECK_OUT',
    ADDITIONALEVIDENCE = 'ADDITIONAL_EVIDENCE',
    PROOFTENANTCOMMUNICATION = 'PROOF_TENANT_COMMUNICATION',
    MIDTERMINSPECTION = 'MID_TERM_INSPECTION',
    REFERENCING = 'REFERENCING',
    GUARANTORCONTACT = 'GUARANTOR_CONTACT',
    SUPPORTINGEVIDENCE = 'SUPPORTING_EVIDENCE',
    TENANTEVIDENCE = 'TENANT_EVIDENCE',
    CLAIMITEM = 'CLAIM_ITEM',
    PROOFOFIDENTITY = 'PROOF_OF_IDENTITY',
    PROOFOFADDRESS = 'PROOF_OF_ADDRESS',
    CLAIMRESPONSE = 'CLAIM_RESPONSE',
    POLICY = 'POLICY',
    KPIDAILYOUTPUT = 'KPI_DAILY_OUTPUT',
    ARBITRATIONSUMMARY = 'ARBITRATION_SUMMARY',
    DOCUSIGN = 'DOCUSIGN',
    CLAIMARCHIVE = 'CLAIM_ARCHIVE',
    SIGNEDADDENDUM = 'SIGNED_ADDENDUM',
    SIGNEDTENANTTERMSANDCONDITIONS = 'SIGNED_TENANT_TERMS_AND_CONDITIONS',
    DAILYSTRIPERECONCILIATION = 'DAILY_STRIPE_RECONCILIATION'
}



